import {
    Comment,
    commentRelationshipKeys,
    commentRelationshipTypes,
    CommentResource,
} from '../../@paco/entities/Comment/Comment'
import { transformCommentFormDataToRequest, transformToComment } from '../../@paco/entities/Comment/CommentTransformers'
import { FetchResult, FetchResultType } from '../../@paco/entities/FetchResult'
import { NotificationCenterHeaderName, NotificationCenterLog } from '../../@paco/entities/NotificationCenter/NotificationCenter'
import { authorizedFetch } from '../../@paco/helpers/authorizedFetch'
import trans from '../../@paco/helpers/trans'
import { generateApiUrl } from '../../@paco/helpers/url'
import isResourceDocument from '../../@paco/japi/guards/isResourceDocument'
import { JapiDocument } from '../../@paco/japi/types/Document'

export interface AddCommentFormData {
    comment: string;
    relationshipKey: commentRelationshipKeys;
    relationshipType: commentRelationshipTypes;
    relationshipId: string;
    eventLogTrackerData?: NotificationCenterLog;
}

const postCommentApiCall = async (addCommentFormData: AddCommentFormData): Promise<FetchResult<Comment, string>> => {
    const commentRequest = transformCommentFormDataToRequest(addCommentFormData)

    try {
        const url = generateApiUrl({
            endpoint: '/comments',
            queryParams: {
                include: 'owner',
            },
        })

        const response = await authorizedFetch(url, {
            method: 'POST',
            body: JSON.stringify({ data: commentRequest }),
            ...addCommentFormData.eventLogTrackerData && {
                headers: {
                    [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(addCommentFormData.eventLogTrackerData),
                },
            },
        })

        const doc: JapiDocument = await response.json()

        if (! isResourceDocument<CommentResource>(doc) || ! doc.data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const comment = transformToComment(doc.data)

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: comment,
        }
    } catch (error) {
        console.error('[postCommentApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}

const noop = () => {}

export {
    noop,
    postCommentApiCall,
}
